<template>
  <div>
    <div class="card">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0" v-if="!is_edit_mode">Add User</h3>
        <h3 class="mb-0" v-if="is_edit_mode">Edit User</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <validation-observer v-slot="{ handleSubmit }" ref="observer">
          <form
            class="needs-validation"
            @submit.prevent="handleSubmit(submit)"
            ref="form_user"
          >
            <div class="row">
              <div class="col-md-12">
                <base-input
                  label="Username"
                  name="username"
                  rules="required"
                  v-model="user.username"
                ></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-input
                  :label="pwd_label"
                  name="password"
                  :rules="{ required: !is_edit_mode, min: 6 }"
                  v-model="user.pwd"
                >
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-input
                  label="Name"
                  name="name"
                  rules="required"
                  v-model="user.name"
                ></base-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-input
                  label="Email"
                  name="email"
                  :rules="{ required: true, email: true }"
                  type="email"
                  placeholder="user@simplysakal.asia"
                  v-model="user.email"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <base-input
                  label="API Token"
                  name="api token"
                  rules="required"
                  v-model="user.token"
                ></base-input>
              </div>
            </div>
            <div class="row">
              <label class="col-md-12 form-control-label">Access Rights</label>
              <div class="col-md-6">
                <base-checkbox
                  v-model="user.permissions.add_task"
                  name="permissions_add_task"
                  value="true"
                  unchecked-value="false"
                >
                  Add tasks
                </base-checkbox>
              </div>
              <div class="col-md-6">
                <base-checkbox
                  v-model="user.permissions.update_task"
                  name="permissions_update_task"
                  value="true"
                  unchecked-value="false"
                >
                  Update task status
                </base-checkbox>
              </div>
              <div class="col-md-6">
                <base-checkbox
                  v-model="user.permissions.send_message"
                  name="permissions_send_message"
                  value="true"
                  unchecked-value="false"
                >
                  Send messages
                </base-checkbox>
              </div>
              <div class="col-md-6">
                <base-checkbox
                  v-model="user.permissions.delete_updates"
                  name="permissions_delete_updates"
                  value="true"
                  unchecked-value="false"
                >
                  Delete updates
                </base-checkbox>
              </div>
            </div>
            <pre class="text-danger" v-if="error">{{ error.err }}</pre>
            <div class="row text-center mt-4">
              <div class="col-md-12">
                <button
                  type="button"
                  class="btn base-button btn-outline-primary"
                  @click="clear()"
                  v-if="!is_edit_mode"
                >
                  CLEAR
                </button>
                <button
                  type="button"
                  class="btn base-button btn-outline-danger"
                  @click="cancel()"
                  v-if="is_edit_mode"
                >
                  CANCEL
                </button>
                <button type="submit" class="btn base-button btn-primary">
                  SAVE
                </button>
              </div>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { mapState } from "vuex";

export default {
  name: "UserForm",
  data() {
    return {
      is_edit_mode: false,
      user: this.initUser(),
      error: {},
      pwd_label: "Password"
    };
  },
  methods: {
    submit() {
      if (this.is_edit_mode) this.saveUser();
      else this.addUser();
    },
    addUser() {
      store
        .dispatch("user/add", this.user)
        .then(() => {
          this.clear();
        })
        .catch(e => {
          this.error = e.response.data;
        });
    },
    saveUser() {
      store
        .dispatch("user/save", this.user)
        .then(() => {
          this.clear();
          this.is_edit_mode = false;
        })
        .catch(e => {
          this.error = e.response.data;
        });
    },
    cancel() {
      this.user = this.initUser();
      this.is_edit_mode = false;
      this.$refs.observer.reset();
      this.error = {};
      this.pwd_label = "Password";
    },
    clear() {
      this.user = this.initUser();
      this.$refs.observer.reset();
      this.error = {};
      this.pwd_label = "Password";
    },
    initUser() {
      return {
        username: "",
        name: "",
        email: "",
        pwd: "",
        token: "",
        permissions: {
          add_task: false,
          update_task: false,
          send_message: false,
          delete_updates: false
        }
      };
    }
  },
  computed: {
    selected_user() {
      return store.state.user.user;
    }
  },
  watch: {
    selected_user(new_val, old_val) {
      this.is_edit_mode = true;
      this.pwd_label = "New Password";
      if (new_val) {
        this.user = new_val;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
